export default "__VITE_ASSET__qWLCUdgo__"